import ServiceHero from '@/components/sections/ServiceHero'

export default function StrategyHero() {
  return (
    <ServiceHero
      serviceName="Strategy"
      titleLines={['Zero Fluff,', 'Just Momentum.']}
      description="We don't just hand over a PDF and wish you luck. We build executable roadmaps that align your digital ecosystem with actual business goals. Zero fluff, just momentum."
    />
  )
}
